import { FormControl, FormGroup } from '@angular/forms';

import { FormType } from './types';
import { INIT_DATA } from './constants';

export const createForm = () => {
  return new FormGroup<FormType>({
    value: new FormControl(INIT_DATA.value, { nonNullable: true }),
    display: new FormControl(INIT_DATA.display, { nonNullable: true }),
  });
};
